import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { find } from "lodash";
import * as moment from 'moment';
import { environment } from "../../../environments/environment";
import { IbanFormat } from "../../common/pipes/iban-format.pipe";
import { OrderLineItemTypeEnum } from "../../shared/enums/order-lineitem-type.enum";
import { StoreConfig } from "../../shared/interface/StoreConfig.interface";
import { CommonService } from "../../shared/services/common.service";
import { DeliveryPreference, PurchaseFlow } from "../common/enumerations";
import { StoreMetaDataConstants } from "../constants/store-metadata.constants";
import { MemberTypeEnum } from "../enums/member-type.enum";
import { AddressType, OrderStatus, PaymentMethodTypes } from "../enums/order-source-type";
import { PaymentCardTypes } from "../enums/payment-card-types.enum";
import { AppCountryConfig } from "../interface/app-config";
import { CheckoutConfig } from "../interface/checkout-config.interface";
import { OrderLineItem } from "../interface/enrollment";
import { FBOBusinessEntity } from "../interface/fbo-business-entity";
import { OrderConfig } from "../interface/order-Config.interface";
import { TaxType } from "../interface/tax-type.interface";
import { AppConfigService } from "../services/app-config.service";
import { CheckoutConfigService } from "../services/checkout-config.service";
import { CustomerService } from "../services/customer.service";
import { OrderConfigService } from "../services/order-config.service";
import { OrderService } from "../services/order.service";
import { Constants } from "../common/constants";
import { PaymentMethodTypeConstants } from "../constants/payment-method-types.constants";

@Component({
    selector: 'app-print-layout',
    templateUrl: '../templates/template1/views/print-layout.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/print-layout.less'
    ],
})

export class PrintLayoutComponent implements OnInit {
  moComponentSettings: any;
  @Input() countries: any;
  @Input() orderDetails: any;
  @Input() distributorInfo: any;
  @Input() orderStoreInfo: any;
  @Input() storeMetaInfo: any;
  activeBusinessEntity: FBOBusinessEntity;
  memberBusinessEntities: FBOBusinessEntity[];
  showPayment: boolean;
  currencySymbols: any;
  currencySymbol: any;
  distributorId: string;
  orderId: string;
  sub: any;
  request: any;
  distributorName: string;
  memberLevel = '';
  fboId: string;
  orderType: any;
  orderNumber: any;
  webOrderId: string;
  globalOrderNumber:any;
  orderDate: any;
  shippingName: string;
  shippingMethod: any;
  shippingInfo: any;
  paymentCardNo: string;
  shippingCountry: string;
  isDmUser: boolean;
  memberAddressDetails: any;
  lineItems: any;
  itemSubTotal: string;
  totalQty: number;
  totalSavings: number;
  shipping: string;
  tax: string;
  total: any;
  totalcc: string;
  paymentCardType: string;
  paymentMethod: string;
  handling: string;
  emailId: string;
  currencyType: any;
  expDate: any;
  latitude = 0;
  longitude = 0;
  shippingImageUrl: string;
  shippingImage: string;
  shippingImageFlag: boolean;
  errormessage = false;
  showDetail = false;
  showLineItem = false;
  empty = '';
  countryName: string;
  languageCode: string;
  shippingAddressInfo: any;
  registerAddress: any;
  states: any;
  countryId: string;
  isoCountryCode: string;
  countryCode: string;
  paymentInfo: boolean;
  paymentDetails: any;
  isPickUp: boolean;
  store: StoreConfig;
  timezoneOffset: number;
  isDistributor: boolean;
  isPrefferedCustomer: boolean;
  totalUnitPrice: number;
  totalDiscountAmount: number;
  totalTaxableAmount: number;
  totalExtendedPrice: number;
  phoneNumberFormat: string;
  registerAddressphoneNumberFormat: string;
  gstTax: number;
  pstTax: number;
  shipFrom: string;
  trackShipmentsURL: string;
  shipmentId: string;
  enrolmentOrPersonalOrder: boolean;
  priceTierName: string;
  isRetailOrder: boolean;
  orderDetailsConfig: OrderConfig;
  myAccountConfig: CheckoutConfig;
  appCountryConfig: AppCountryConfig;
  corporateVatId: string;
  vatNumber: string;
  enableVatinInvoice: string;
  participatingCountries: any[];
  vatBreakdownStores=['GBR', 'IRL', 'ILN'];
  vatBreakdownCountry: boolean;
  donationItemExist: OrderLineItem;
  organizationNumber:string;
  placeOfIncorporation:string;
  taxCertificateNote:string;
  taxType=TaxType;
  showWatermarkInInvoice: boolean;
  watermarkMessage:string;
  hasOrderLevelDiscount: boolean = false;
  hasBondedProduct: boolean = false;
  hasNonBondedProduct: boolean = false;
  totalRetailPrice:number;
  totalDiscount:number;
  bondedProduct: boolean;
  bwpBaseChargeAmount: number;
  isSingleOrDirect: boolean;
  obfuscatedIban: string;
  creditorID: any;
  isServiceOrder: boolean;
  memberAddressInfo: any;
  shippingTaxRate: number;
  displaySystemOrderNumber: boolean;
  paymentMethodTypeConstants: Constants = PaymentMethodTypeConstants;
  paymentType: any = PaymentMethodTypes;
  isIntegratedTerminalAdyenPymt: boolean;
  removeCommaOnInvoive :boolean;

  constructor(
 private _appConfigService: AppConfigService,
 private _checkoutConfigService: CheckoutConfigService,
 private _commonService: CommonService,
 private _orderConfig: OrderConfigService,
 private _orderService: OrderService,
 private _translatePipe: TranslateService,
 private _ibanFormatPipe: IbanFormat,
 private _customerservice: CustomerService,
  ) { }

    ngOnInit() {
        this.getMemberDetailById();
        this.getCountryConfig();
        this.getOrderDetails(this.orderDetails);
        if (this.distributorInfo && this.distributorInfo.memberTypeId
             && (this.distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
            this.isDistributor = true;
        }
        if (this.distributorInfo && this.distributorInfo.memberTypeId && (this.distributorInfo.memberTypeId === MemberTypeEnum.FPC)) {
            this.isPrefferedCustomer = true;
        }
    //    this.vatNumber = this.store.vatNumber; 
        this.getStoreMetaData();
        this.getStoresInfo();
        window.scrollTo(0, 0);
    }

    /**
     * will get Country Based Configuration Values
     * @returns void
     * @memberof OrderDetailsComponent
     */
    getCountryConfig(): void {
        if (this.orderDetails) {
            this.appCountryConfig = this._appConfigService.getSettings(this.orderDetails.countryCode, this.distributorInfo);
        }
    }


    /**
     * getOrderDetails Method used to get the order details
     * @param  {string} webOrderId
     * @returns void
     */
    getOrderDetails(orderdetails: any): void {
        if (orderdetails) {
            if (!orderdetails.shipToName && orderdetails.firstName && orderdetails.lastName) {
                orderdetails.shipToName = orderdetails.firstName + ' ' + (orderdetails.middleName && orderdetails.displayMiddleName
                    ? orderdetails.middleName + ' ' : '') + orderdetails.lastName;
            }
            if (orderdetails.isDM) {
                this.isDmUser = orderdetails.isDM;
                this.totalDiscountAmount = orderdetails.totalDiscountAmount &&
                    orderdetails.totalDiscountAmount > 0 ? orderdetails.totalDiscountAmount : null;
            }
            const countrycode = orderdetails.countryCode;
            if(environment.removeCommaOnInvoice){
            this.removeCommaOnInvoive = environment.removeCommaOnInvoice.split(',').includes(countrycode);
            }
            this.myAccountConfig = this._checkoutConfigService.getSettings(countrycode, null);
            this.orderDetailsConfig = this._orderConfig.getSettings(countrycode, this.distributorInfo);
            this.vatBreakdownCountry = this.isVatBreakdownCountry(countrycode);
            this.orderDetails = orderdetails;
            this.displaySystemOrderNumber = this.myAccountConfig && this.myAccountConfig.displaySystemOrderNumber && this.orderDetails && this.orderDetails.source === 'POS' ? true : false;
            this.isRetailOrder = this.orderDetails.orderTypeId === PurchaseFlow.Retail;
            this.isServiceOrder = this.orderDetails.orderTypeId === PurchaseFlow.SERVICE;
            if (this.orderDetails && this.orderDetails.orderTypeId
                && this.orderDetails.orderTypeId === PurchaseFlow.Enrollment
                || this.orderDetails.orderTypeId === PurchaseFlow.Personal_Order) {
                this.enrolmentOrPersonalOrder = true;
            }
            this.getTranslatedProducts(countrycode);
            this.prepareOrderDetailsData(this.orderDetails);
            this.getOrderPaymentInfo(this.orderDetails.billingInfo);
            this.emptyCheck();

        }
    }


    /**
     * @description display order vat tax based on order type id and country taxinclusive
     * @memberof OrderDetailsComponent
     */
    displayOrderVatTax(): void {
        if (this.appCountryConfig.enableVATCalculation && this.orderDetailsConfig.displayVat && this.orderDetails) {
            if (this.orderDetails.orderTypeId === PurchaseFlow.Enrollment && this.orderDetails.initialOrder
                && this.orderDetails.vatRegistered) {
                this.orderDetailsConfig.displayVat = true;
            } else if (this.shippingAddressInfo && this.shippingAddressInfo.countryId && this.participatingCountries
                && this.participatingCountries.length && this.orderDetails.vatRegistered) {
                const country = this.participatingCountries
                    .find(x => x.countryId === this.shippingAddressInfo.countryId);
                this.orderDetailsConfig.displayVat = this.getCountryTaxInclusiveInfo(country);
            } else {
                this.orderDetailsConfig.displayVat = false;
            }
        } else if (this.orderDetailsConfig.displayVat && !this.orderDetailsConfig.enableVATCalculation) {
            this.orderDetailsConfig.displayVat = true;
          } else {
            this.orderDetailsConfig.displayVat = false;
          }
          if(this.vatBreakdownCountry){
            this.orderDetailsConfig.displayVat = true;
        }
    }



    /**
    * @description to get taxinclusive info
    * @memberof OrderDetailsComponent
    */
    getCountryTaxInclusiveInfo(country: any): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }


  /**
   *
   * @param storeId
   */
    private getStoreMetaData(): void {
        if (this.storeMetaInfo && this.storeMetaInfo.length > 0) {
            // const metaData = this.storeMetaInfo.find(x => (x.attribute &&
            //     x.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()));
            // if (metaData && metaData.metaDataValue) {
            //     this.corporateVatId = metaData.metaDataValue;
            // }
            this.storeMetaInfo.forEach((metaData) => {
                if (metaData && metaData.metaDataValue && metaData.attribute) {
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()) {
                        this.corporateVatId = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.ORGANIZATION_NUMBER.toLowerCase()) {
                        this.organizationNumber = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.TAX_CERTIFICATE_NOTE.toLowerCase()) {
                        this.taxCertificateNote = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.PLACE_OF_INCORPORATION.toLowerCase()) {
                        this.placeOfIncorporation = metaData.metaDataValue;
                    }
                    if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_WATERMARK_IN_INVOICE.toLowerCase()) {
                        this.showWatermarkInInvoice = (metaData.metaDataValue.toLowerCase() == 'true');
                        if (this.showWatermarkInInvoice) this.watermarkMessage = this.populateWatermark();
                    } if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CREDITOR_ID.toLowerCase()) {
                        this.creditorID = metaData.metaDataValue;
                    }
                }
            });
        }
    }
    private getStoresInfo(): void {
        if (this.orderStoreInfo) {
            this.vatNumber = this.orderStoreInfo.vatNumber;
            this.enableVatinInvoice = this.orderStoreInfo.enableVatInInvoice;
            this.orderStoreInfo.ccNumberDecimals = 3;
            this.orderStoreInfo.ccNumberFormat = 'CR';
            this.orderStoreInfo.ccSymbol = 'CC';
            this.timezoneOffset = this.orderStoreInfo.timeZoneOffset ? (this.orderStoreInfo.timeZoneOffset * 60) : 0;
        }
    }


    /**
     * prepareOrderDetailsData Method used to set the order details data
     * @param  {any} orderDetails
     * @returns void
     */
    prepareOrderDetailsData(orderDetails: any): void {
        let symbol: any;
        this.distributorName = this.distributorInfo.firstName + ' ' + this.distributorInfo.lastName;
        this.memberLevel = this.distributorInfo.memberTitle;
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.orderDetails.countryCode);
        this.priceTierName = this._commonService.getDiscountPriceLevel(this.orderDetails.priceTierId,
            this.orderDetails.memberLevelDiscount, this.orderDetails.memberTypeId, enableWHLSAL00ForAsstSupervisor);
        this.fboId = this.orderDetails.distrubutorId;
        this.orderNumber = this.orderDetailsConfig.displayErpNumber? this.orderDetails.erpNumber :this.orderDetails.orderNumber;
    this.webOrderId = this.orderDetails.webOrderId;
    this.globalOrderNumber= this.orderDetails && this.orderDetails.globalOrderNumber ? this.orderDetails.globalOrderNumber :null;
        this.orderDate = moment.utc(this.orderDetails.createdDate).format('DD-MMM-YYYY');
        this.orderDetails.orderLineItems.sort((a: any, b: any) => {
            return a.orderLineNumber - b.orderLineNumber;
        });
        let orderLineItems = []; 
        //this.lineItems = this.orderDetails.orderLineItems;
        if(this.orderDetailsConfig.displayVatTaxLineItem  || this.vatBreakdownCountry){
            this.orderDetails.orderLineItems.forEach(lineItem=>{
                if(lineItem.lineItemTypeId!=OrderLineItemTypeEnum.CHILD_PRODUCT){
                    orderLineItems.push(lineItem);
                }
            })
            this.lineItems = orderLineItems;
        }
        else{
            this.lineItems = this.orderDetails.orderLineItems;
        }
        this.hasOrderLevelDiscount = this.orderDetails.orderLevelDiscount ? true : false;
        if (this.orderDetailsConfig && this.orderDetailsConfig.isDEUCountry && this.orderDetails && this.orderDetails.taxMetaData && this.orderDetails.taxMetaData.orderTaxCharges) {
            const items = this.orderDetails.taxMetaData.orderTaxCharges;
            items.forEach((element, index) => {
                if (element.lineNo === 0) {
                    if (this.hasOrderLevelDiscount) {
                        items[index].taxChargeBased = element.taxChargeBased - element.taxAmount;
                    }
                    this.shippingTaxRate = element.taxRate;
                }
            });
        }
        const hasNonBondedProduct = this.lineItems.find((x) => !x.bondedProduct)
        if (this.hasOrderLevelDiscount) {
            this.hasBondedProduct = true;
            this.orderDetails.taxMetaData.orderTaxCharges = this.orderDetails.taxMetaData.orderTaxCharges.filter(item => item.taxRate > 0 || this.orderDetailsConfig.displayTotalColumnOnTaxChargeTypeZero);
        }
        if (hasNonBondedProduct) {
            this.hasBondedProduct = false;
            this.hasNonBondedProduct = true;
        }
        this.donationItemExist = this.orderDetails.orderLineItems.find((x)=>x.lineItemTypeId == OrderLineItemTypeEnum.DONATION_PRODUCT);
        this.itemSubTotal = this.orderDetails.orderSubTotal;
        this.totalQty = this.getTotalQuantity(this.lineItems);
        this.shipping = this.orderDetailsConfig.calculateShippingWithTax && this.orderDetails.shippingCost && this.orderDetails.shippingTax
            && (!this.orderDetails.vatRegistered || this.orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) ?
            this.orderDetails.shippingCost + this.orderDetails.shippingTax : this.orderDetails.shippingCost;
        this.orderDetails.shippingCost = this.orderDetailsConfig.calculateShippingWithTax && this.orderDetails.shippingCost
            && this.orderDetails.shippingTax && (!this.orderDetails.vatRegistered ||
                this.orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR)
            ? this.orderDetails.shippingCost + this.orderDetails.shippingTax : this.orderDetails.shippingCost;
        this.orderDetails.shippingCost = this.orderDetails.shippingCost ? this.orderDetails.shippingCost : 0;
        this.tax = this.orderDetails && this.orderDetails.retailDeliveryFee ? (this.orderDetails.orderTax - this.orderDetails.retailDeliveryFee) : this.orderDetails.orderTax;
        this.total = (this.orderDetails.orderTotal === '' ? '0.0' : this.orderDetails.orderTotal);
        this.totalcc = this.orderDetails.orderTotalCC;
        this.emailId = this.orderDetails.email;
        //this.handling = this.orderDetails.handling;
        this.currencyType = this.orderDetails.currencyType;
        symbol = find(this.currencySymbols, { currencyCode: this.currencyType });
        this.currencySymbol = symbol ? symbol.currencySymbol : '$';
        if (this.orderDetails.orderShippings && this.orderDetails.orderShippings.length > 0) {
            if (this.orderDetails.orderShippings[0].deliveryPreferenceId === DeliveryPreference.PICKUP) {
                this.isPickUp = true;
            } else {
                this.getShipMethodInfo(this.orderDetails);
                if (this.orderDetailsConfig && !this.orderDetailsConfig.isDisplayShipping) {
                    this.orderDetailsConfig.handlingDisplay = true;
                }
            }
        }

        if (this.orderDetails.addresses && this.orderDetails.addresses.length > 0) {
            this.getMemberAddressByMemberId(this.orderDetails.addresses);
            this.getParticipatingCountries(this.orderDetails.countryCode);
            this.displayOrderVatTax();
                this.calculateTotals(this.lineItems, this.orderDetails.shippingCost,
                    this.orderDetails.importFeeValue);
        } else {
            this.displayOrderVatTax();
            this.calculateTotals(this.lineItems, this.orderDetails.shippingCost,
                this.orderDetails.importFeeValue);
        }
        if (this.orderDetails && this.orderDetails.taxMetaData
            && this.orderDetails.taxMetaData.orderTaxCharges && this.orderDetails.taxMetaData.orderTaxCharges.length) {
            const gst = this.orderDetails.taxMetaData.orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
            const pst = this.orderDetails.taxMetaData.orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
            this.gstTax = gst ? gst.taxAmount : 0;
            this.pstTax = pst ? pst.taxAmount : 0;
        }
        // PS2020-489 --> USA Tax issue
        if (this.orderDetails && (!this.orderDetails.orderTax || this.orderDetails.orderTax <= 0)
            && this.orderDetails.countryCode === 'USA' && this.orderDetails.taxMetaData
            && this.orderDetails.taxMetaData.orderTaxCharges
            && this.orderDetails.taxMetaData.orderTaxCharges.length > 0) {
            const slsTax = this.orderDetails.taxMetaData
                .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.SLS_TAX);
            this.tax = slsTax ? slsTax.taxAmount : 0;

        }
        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.orderDetails.countryCode);
    }


    /**
    * get total quantity from orderline items
    * @returns number
    */
    getTotalQuantity(orderLineItems: any): number {
        let totalQty = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(item => {
                if(!item.depositFeeProduct){
                totalQty = totalQty + item.quantity;
                }
            });
        }
        return totalQty;
    }


    /**
    * get totals from orderline items
    * @returns number
    */
    calculateTotals(orderLineItems: any, shippingCost: number, importFeeValue: number) {
        let totalUnitPrice = 0;
        let totalTaxableAmount = 0;
        let totalExtendedPrice = 0;
        let totalRetailPrice = 0;
        let totalBwpExtendedPrice = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(item => {
                totalUnitPrice = totalUnitPrice + item.unitPaidPrice;
                totalRetailPrice = totalRetailPrice + (item.unitRetailPrice * item.quantity);
                totalTaxableAmount = totalTaxableAmount + item.totalRetailPrice;
                totalExtendedPrice = totalExtendedPrice + item.totalAmount;
                if(item.bondedProduct)
                    totalBwpExtendedPrice = totalBwpExtendedPrice + item.totalAmount
            });
        }
        let wholesaleQualified: boolean;
        let optin: boolean;
        if (this.orderDetails) {
            wholesaleQualified = this.orderDetails.wholesaleQualified;
            optin = this.orderDetails.optin;
        }
        // const discountPerc = this._commonService.getDiscountPerc(memberTitleId, wholesaleQualified, optin);
        const discountPerc = this.orderDetails.memberLevelDiscount;
        this.totalSavings = discountPerc ? (totalRetailPrice * discountPerc) / 100 : 0;
        this.totalUnitPrice = totalUnitPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalTaxableAmount = totalTaxableAmount + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalExtendedPrice = totalExtendedPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        if(totalBwpExtendedPrice) {
            this.totalDiscountAmount = this.orderDetails.orderLevelDiscount;
            this.bwpBaseChargeAmount = totalBwpExtendedPrice - this.totalDiscountAmount;
          }
    }


    emptyCheck() {

        if (this.shippingAddressInfo && this.shippingAddressInfo.shipToName === this.empty
            && this.shippingAddressInfo.phone === this.empty && this.shippingAddressInfo.email === this.empty
            && this.shippingAddressInfo.addressLine1 === this.empty && this.shippingAddressInfo.addressLine1 === this.empty
            && this.shippingAddressInfo.city === this.empty
            && this.shippingCountry === this.empty && this.shippingAddressInfo.stateCode === this.empty) {
            this.showDetail = false;
        } else { this.showDetail = true; }
        if (this.paymentCardType === this.empty && this.expDate === this.empty && this.paymentCardNo === this.empty) {
            this.showPayment = true;
        } else { this.showPayment = false; }

        if (this.lineItems && this.lineItems.length === 0) {
            this.showLineItem = true;
        } else { this.showLineItem = false; }
    }


    /**
     * @description  prepare MemberAddress
     * @author Akhil
     * @date 2020-11-27
     * @param {*} addresses
     * @memberof PrintLayoutComponent
     */
    getMemberAddressByMemberId(addresses: any) {
        this.shippingAddressInfo = null;
        this.memberAddressDetails = [];
        addresses.forEach((address: any) => {
            let name = '';
            if (address && address.firstName && address.lastName) {
                const middleName = this.orderStoreInfo && this.orderStoreInfo.displayMiddleName && address.middleName ? address.middleName : '';
                name = address.firstName + ' ' + (middleName ? middleName + ' ' : '') + address.lastName;
            } else if (this.shippingAddressInfo && address.shipToName || address.name) {
                name = address.shipToName || address.name;
            }
            this.memberAddressDetails.push({
                id: address.id,
                shipToName: name || address.name || '',
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                addressType: address.addressType,
                city: address.city,
                stateId: address.stateId,
                countryId: address.countryId,
                state: address.state,
                stateCode: address.stateCode,
                country: address.country,
                countryCode: address.countryCode,
                postalCode: address.postalCode,
                addressVerified: address.addressVerified,
                phone: address.phone,
                email: address.email,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                displayMiddleName: this.orderStoreInfo ? this.orderStoreInfo.displayMiddleName : false
            });
        });
        if (this.memberAddressDetails.length > 0) {
            const shippingInfo = this.memberAddressDetails.find((address: any) =>
                (address.addressType === AddressType.SHIPPING) || (address.addressType === AddressType.PICKUP)|| (address.addressType === AddressType.PICKUP_PERSON) ||  (address.addressType === AddressType.DROPSHIP));
            this.shippingAddressInfo = shippingInfo;
            this.shippingCountry = this.shippingAddressInfo.country;
        }
    }


    /**
     * @description  to prepare payment Detaiils
     * @author Akhil
     * @date 2020-11-27
     * @param {*} paymentResonse
     * @memberof PrintLayoutComponent
     */
    getOrderPaymentInfo(paymentResonse) {
        if (paymentResonse) {
            this.paymentInfo = true;
            this.paymentDetails = paymentResonse;
            if(this.appCountryConfig && this.appCountryConfig.displayStatementForWavePayment){
                if(this.paymentDetails.paymentMethod === PaymentMethodTypes.Money_order)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Wave;
                else if(this.paymentDetails.paymentMethod === PaymentMethodTypeConstants.Orange_Money)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Orange_Money;
            }           
            this.paymentMethod = this.paymentDetails.paymentMethod ? this.paymentDetails.paymentMethod : 'NA';
            this.isSingleOrDirect = this.paymentMethod && (this.paymentMethod === PaymentMethodTypes['Direct_Debit'] || this.paymentMethod === PaymentMethodTypes['Single_Debit'])
            if (this.isSingleOrDirect)
                this.obfuscatedIban = this._ibanFormatPipe.transform(this.paymentDetails.accountNumber);
                const paymentLabel = this.paymentMethod ?
                PaymentMethodTypes[this.paymentMethod] ? this._commonService.getPaymentTypeLabel(this.paymentMethod) : this.paymentMethod : 'NA';
                this.isIntegratedTerminalAdyenPymt=(paymentLabel==PaymentMethodTypeConstants.Integrated_Terminal_Adyen? true: false);
            this.paymentCardType = this.paymentDetails.cardType ? this.paymentDetails.cardType : 'NA';
            const cardLabel = this.paymentCardType ?
                PaymentCardTypes[this.paymentCardType] ? PaymentCardTypes[this.paymentCardType] : this.paymentCardType : 'NA';
            this.paymentCardNo = this.paymentDetails.maskedCard ? this.paymentDetails.maskedCard : 'NA';
            this.expDate = this.paymentDetails.expiryMonth ? (this.paymentDetails.expiryMonth +
                '/' + this.paymentDetails.expiryYear.substring(2, 4)) : 'NA';

            this.moComponentSettings = this.preparePaymentLables(paymentLabel, cardLabel);
        }
    }


    getShipMethodInfo(orderDetails: any) {
        if (this.orderDetails && this.orderDetails.orderShippings.length > 0
            && this.orderDetails.orderShippings[0].shipMethodId && this.orderDetails.storeId) {
            this.shipFrom = this.orderDetails.orderShippings[0].distributionCenter;
            this.shippingMethod = this.orderDetails.shippingInfo.shippingMethod;
            this.shippingImage = this.shippingMethod.replace(/\s/g, '');
        }
    }

    /**
     * setDefaultShippingPic Method used to display default text for Shipping method
     * @returns void
     */
    setDefaultShippingPic(): void {
        this.shippingImageFlag = false;
    }

    /**
     *
     * @param items
     */
    getItemVolumeSum(items): number {
        if (this.appCountryConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        } else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    }
    getItemTaxChargeBasedSum(items): number {
        return items
          .map(function (x) { return x.taxChargeBased; })
          .reduce(function (a, b) { return a + b; });
      }

  /**
   * orderInvoice Method used to implement print functionality
   * @returns void
   */
  orderInvoice(): void {
    (window as any).print();
  }


    /**
     * get Participating countries
     * @param countryCode
     */
    private getParticipatingCountries(countryCode: string): void {
        if (this.countries) {
            this.participatingCountries = this.countries;
            if (this.appCountryConfig.enableVATCalculation) {
                this.orderDetailsConfig.displayVat = this.distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR ? true : false;
            }
            if(this.vatBreakdownCountry){
                this.orderDetailsConfig.displayVat = true;
            }
            this.displayOrderVatTax();
        }
    }

    /**
     * @description prepare Payment Types ;
     * @author Akhil
     * @date 2020-11-27
     * @param {*} paymentLabel
     * @param {*} cardLabel
     * @returns {*}
     * @memberof PrintLayoutComponent
     */
    preparePaymentLables(paymentLabel: any, cardLabel: any): any {
        const paymentTypes = PaymentMethodTypes;
        const payementDetails: any = {
            paymentMethodTypes: paymentTypes,
            paymentMethodLabel: paymentLabel,
            cardTypeLabel: cardLabel
        }
        return payementDetails;
    }

    /**
     * @description getregistered Address
     * @author Akhil
     * @date 2020-11-30
     * @memberof PrintLayoutComponent
     */
    getMemberDetailById(): void {
        this._customerservice.getMemberBasicInfoById(this.orderDetails.memberId).subscribe((memberResponse) => {
            if (memberResponse) {
                this.memberAddressInfo = memberResponse;
                if (this.memberAddressInfo) {
                    this.memberBusinessEntities = this.memberAddressInfo.businessEntities ? this.memberAddressInfo.businessEntities : null;
                    if (this.memberAddressInfo.businessEntityHistories) {
                        this.memberBusinessEntities.push(...this.memberAddressInfo.businessEntityHistories);
                    }
                    this.registerAddress = this.memberAddressInfo.address;
                    this.registerAddress.firstName = this.registerAddress.firstName ? this.registerAddress.firstName
                        : this.memberAddressInfo.firstName ? this.memberAddressInfo.firstName : null;
                    if(this.orderStoreInfo && this.orderStoreInfo.displayMiddleName){
                    this.registerAddress.middleName = this.registerAddress.middleName ? this.registerAddress.middleName 
                    : this.memberAddressInfo.middleName ? this.memberAddressInfo.middleName : null;
                    }
                    this.registerAddress.lastName = this.registerAddress.lastName ? this.registerAddress.lastName
                        : this.memberAddressInfo.lastName ? this.memberAddressInfo.lastName : null;
                    this.registerAddress.phoneNumber = this.registerAddress.phoneNumber ? this.registerAddress.phoneNumber
                        : this.memberAddressInfo.phone ? this.memberAddressInfo.phone : null;
                    this.registerAddress.email = this.registerAddress.email ? this.registerAddress.email
                        : this.memberAddressInfo.email ? this.memberAddressInfo.email : null;
                    this.registerAddressphoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.registerAddress.countryCode);
                    this.prepareBusinessEntity();
                }
            }
           
        });
        
    }

    getFlpLogo() {
        return environment.uiTemplateBaseUrl + '/images/flpi-logo.jpg';
    }

    /**
     * @description To get translated product for order invoice
     * @date 2021-11-17
     * @memberof PrintLayoutComponent
     */
    getTranslatedProducts(countryCode: string): void {
        const purchaseFlowType = this._commonService.getPurchaseFlowType(this.orderDetails.memberTypeId,
            this.orderDetails.wholesaleQualified, this.appCountryConfig.fpc5PercentEnabled, false, this.distributorInfo.memberTitleId);
        const language: string = JSON.parse(localStorage.getItem('appadmin.language'));
        let productIds: number[] = [];
        productIds = this.orderDetails.orderLineItems.map((x: any) => x.productId);
        if (productIds && productIds.length > 0) {
            this._orderService.getProductsByIds(productIds, language, this.orderDetails.storeId,
                this.distributorInfo.memberTitleId, purchaseFlowType, countryCode, this.orderDetails.wholesaleQualified,
                this.orderDetails.optIn, this.orderStoreInfo.taxInclusive
            ).subscribe((products) => {
                if (products) {
                    this.orderDetails.orderLineItems.forEach(lineItem => {
                        const filteredProduct = products.find(x => x.id === lineItem.productId);
                        if (filteredProduct && filteredProduct.displayName) {
                            lineItem.productName = filteredProduct.displayName;
                        }
                    });
                }
            });
        }
        this.totalRetailPrice = this.orderDetails.orderLineItems.reduce((sum, y) => {
            if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
              return sum + (y.unitRetailPrice * y.quantity);
            }
            return sum;
          }, 0);
          this.totalDiscount = this.orderDetails.orderLineItems.reduce((sum, y) => {
            if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
              return sum + ((y.unitRetailPrice - y.unitPaidPrice) * y.quantity)
            }
            return sum;
          }, 0);
    }

    isVatBreakdownCountry(isoCountryCode: string): boolean {
        return this.vatBreakdownStores.find((country) => country === isoCountryCode.toUpperCase()) ? true : false;
    }
    populateWatermark() {
        let msg = "";
        if (this.orderDetails && this.orderDetails.orderStatusId) {
            if (this.orderDetails.orderStatusId == OrderStatus.Pending) return msg = this._translatePipe.get('order.Add Watermark to Invoice-Pending')['value'];
            if (this.orderDetails.orderStatusId == OrderStatus.Cancelled) return msg = this._translatePipe.get('order.Add Watermark to Invoice-Cancelled')['value'];
        }
        return msg;
    }
    prepareBusinessEntity() {
        this.activeBusinessEntity = null;
        let businessEntityId = null;
        businessEntityId = this.orderDetails && this.orderDetails.businessEntityId ? this.orderDetails.businessEntityId : null;
        if (this.memberBusinessEntities && businessEntityId) {
          this.activeBusinessEntity = this.memberBusinessEntities.find((item: FBOBusinessEntity) =>
            item && item.id === businessEntityId
          );
        }
      }

      prepareBusinessEntityByOrderDate() {
        this.activeBusinessEntity = null;
        let businessEntityId = null;
        const fromDateFormat = 'DD-MM-YYYY';
        const toDateFormat = 'YYYY-MM-DD';
        businessEntityId = this.orderDetails && this.orderDetails.businessEntityId ? this.orderDetails.businessEntityId : null;
        const orderedDate =  moment(this.orderDetails.createdDate).utcOffset(this.timezoneOffset).format(toDateFormat);
        if (this.memberBusinessEntities && businessEntityId && orderedDate) {
          const country = this.countries && this.countries.find((country) => country.isocodeThree && country.isocodeThree.toLowerCase() === this.orderDetails.countryCode.toLowerCase());
          this.activeBusinessEntity = this.memberBusinessEntities.find((item: FBOBusinessEntity) =>
            item && item.id === businessEntityId
            && country && country.countryId === item.countryCodeId
          );
          let isValid = false;
          if(this.activeBusinessEntity && this.activeBusinessEntity.startDate){
            if(this.activeBusinessEntity.startDate){
              const start = this.activeBusinessEntity.startDate ? moment(this.activeBusinessEntity.startDate,fromDateFormat).format(toDateFormat) : null;
              const end = this.activeBusinessEntity.endDate ? moment(this.activeBusinessEntity.endDate,fromDateFormat).format(toDateFormat) : null;
              if(start){
                if(end){
                  isValid = moment(orderedDate).isBetween(start,end,null,'[]');
                } else {
                  isValid = moment(orderedDate).isSameOrAfter(start);
                }
              }
            }
          }
          if(!isValid){
            this.activeBusinessEntity = null;
          }
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/print-layout.component.ts